module.exports = __webpack_public_path__ + "img/1F1F1-1F1E8.64ab534a.svg";